import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';

export type GetCodelistRecordCustomIdsByCodelistRecordIdsResponse = {
	recordCustomIds: Record<string, string>;
};

export const useGetCodelistRecordCustomIdsByCodelistRecordIds = (
	props: { projectId: string; codelistRecordIds: string[] },
	opts?: Partial<UseQueryOptions<GetCodelistRecordCustomIdsByCodelistRecordIdsResponse>>
) => {
	const uniqueCodelistRecordIds = [...new Set(props.codelistRecordIds.filter(Boolean))];

	return useQuery<GetCodelistRecordCustomIdsByCodelistRecordIdsResponse>({
		queryKey: [
			'getRecordCustomIdsByCodelistRecordIds',
			props.projectId,
			uniqueCodelistRecordIds
		],
		queryFn: () => {
			if (uniqueCodelistRecordIds.length === 0) {
				return Promise.resolve({
					recordCustomIds: {}
				});
			}

			return makeRequest<GetCodelistRecordCustomIdsByCodelistRecordIdsResponse>({
				method: 'getRecordCustomIdsByCodelistRecordIds',
				service: 'cde',
				data: {
					projectId: props.projectId,
					codelistRecordIds: uniqueCodelistRecordIds
				}
			});
		},
		...opts
	});
};
